import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=9beff7ac&scoped=true&"
import script from "./uploader.vue?vue&type=script&lang=js&"
export * from "./uploader.vue?vue&type=script&lang=js&"
import style0 from "./uploader.vue?vue&type=style&index=0&id=9beff7ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9beff7ac",
  null
  
)

export default component.exports